module.exports = __webpack_public_path__ + "img/l-cb6-1.d22e27dc.gif";